var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCee(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_487_7090)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.3938 14.7857C13.3938 15.0888 13.2733 15.3795 13.059 15.5938C12.8446 15.8081 12.554 15.9286 12.2509 15.9286H1.96512C1.66201 15.9286 1.37133 15.8081 1.157 15.5938C0.942674 15.3795 0.822266 15.0888 0.822266 14.7857V2.21427C0.822266 1.91116 0.942674 1.62047 1.157 1.40615C1.37133 1.19182 1.66201 1.07141 1.96512 1.07141H8.34888C8.65198 1.07141 8.94268 1.19182 9.157 1.40615L13.059 5.30811C13.2733 5.52243 13.3938 5.81313 13.3938 6.11622V14.7857Z",
    stroke: "currentColor",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.74609 7.78564H10.6032",
    stroke: "currentColor",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.74609 11.75H10.6032",
    stroke: "currentColor",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.32617 11.6852L4.28376 12.6428L5.87974 10.4084",
    stroke: "currentColor",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.32617 7.64959L4.28376 8.60718L5.87974 6.3728",
    stroke: "currentColor",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_487_7090"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "currentColor",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCee);
export default __webpack_public_path__ + "static/media/icon-cee.a45017db56aeeb7ce4a414cad0718822.svg";
export { ForwardRef as ReactComponent };